// was ourRouter.js
import { getPageContent, getNVEARContent } from '../services/pageService';
import { isset } from './useSiteRepository'

let NVEAROverviewMapping: any
const pageTypeNVEAROverview: any = {
  news: "DN",
  event: "DE",
  action: "DA",
  reference:"DR",
  vacancy:"DV"
};

// CHECK: are reservedPathParts being used in code anywhere?
// breadCrumbs.vue line 104

export const usePageRepository = (url?: any) => {
  let pageItem

  const findPageByCurrentURL = async (url: any) => {
    const slugs = url.params?.slug || [];
    let slugsCopy = [...slugs]
    const hasLanguagePrefix = !noLanguageInURL(url);
    if (hasLanguagePrefix) slugsCopy.shift();

    const reservedPathPars = ['filter', 'compare'];
    const reservedIndex = slugsCopy.findIndex((slug: string) => reservedPathPars.includes(slug));
    if (reservedIndex !== -1) slugsCopy = slugsCopy.slice(0, reservedIndex);

    pageItem = usePageOverviewStore().getPageByRoute(slugsCopy);
    return await determinePage(pageItem);
  }

  let returnPage: any = "";
  const determinePage = async (pageItem?: PageOverview) => {
    if (noParamSlugs(url)) { // equals line 48 in ourRouter.js
      returnPage = formatIndexObject()
      useCurrentPageStore().populate(returnPage, 'indexPage')
    }

    else if (pageItem) { // equals line 51 in ourRouter.js
      if (pageNotFound(url)) { // equals line 52 in ourRouter.js
        returnPage = formatNotFoundObject()
      }

      else if (noLanguageInURL(url)) { // equals line 56 in ourRouter.js
        if (isNVEARPage(pageItem, url)) { // equals line 63 in ourRouter.js, but the other way around
          returnPage = await formatNVEARPage(url) // equals line 68 in ourRouter.js
          const pageType = getNVEARType(url)
          useCurrentPageStore().populate(returnPage, pageType)
        }

        else { // equals line 65 in ourRouter.js
          returnPage = await formatContentPage(pageItem, url)
          useCurrentPageStore().populate(returnPage, 'content')
        }
      }
      else {
        if (languageInURLNoRouteParam(url)) { // equals line 79 in ourRouter.js
          returnPage = formatIndexObject();
          useCurrentPageStore().populate(returnPage, 'indexPage')
        }

        else {
          // isNVEARorContent function van onderstaande if en else
          if (isNVEARPage(pageItem, url)) { // equals line 87 in ourRouter.js, but the other way around
            returnPage = await formatNVEARPage(url) // equals line 92 in ourRouter.js
            const pageType = getNVEARType(url)
            useCurrentPageStore().populate(returnPage, pageType)
          }

          else { // equals line 89 in ourRouter.js
            returnPage = await formatContentPage(pageItem, url);
            useCurrentPageStore().populate(returnPage, 'content')
          }
        }
      }
    }
    else {
      // pageItem not found — check if it's an NVEAR detail page
      if (languageInURLNoRouteParam(url)) { // equals line 79 in ourRouter.js
        returnPage = formatIndexObject();
        useCurrentPageStore().populate(returnPage, 'indexPage')
      }
      else if (isNVEARPage(pageItem, url)) {
        returnPage = await formatNVEARPage(url)
        const pageType = getNVEARType(url)
        useCurrentPageStore().populate(returnPage, pageType)
      } else {
        returnPage = await formatContentPage(pageItem, url)
        useCurrentPageStore().populate(returnPage, 'content')
      }
    }
    return returnPage;
  }

  if (url) {
    return findPageByCurrentURL(url)
  }
}

export const noParamSlugs = (url: any) => { return (!isset(url.params?.slug) || url.params?.slug?.length == 0 || url.params?.slug?.[0] == "") }

const formatIndexObject = () => {
  const siteSettings = useSiteSettingsStore();
  let siteSettingsObj: any = { ...siteSettings.$state };
  siteSettingsObj["MetaDescription"] =    siteSettings.HomePageMetaDescription,
  siteSettingsObj["MetaTitle"] =          siteSettings.HomePageMetaTitle,
  siteSettingsObj["MetaKeywords"] =       siteSettings.HomePageMetaKeyWords,
  siteSettingsObj["BrowserTitle"] =       siteSettings.HomePageTitle
  siteSettingsObj["Title"] =              siteSettings.HomePageTitle
  siteSettingsObj["NameUrl"] =            ""
  siteSettingsObj["NameMenu"] =           "Start"

  // add pagetype IP index page to the object
  siteSettingsObj["PageType"] = "IP";
  return siteSettingsObj;
}

export const pageNotFound = (url: any) => {
  return (url.params?.slug?.[0] == '404'  ||(isset(url.params?.slug?.[1])&& url.params?.slug?.[1] == '404')) }

const formatNotFoundObject = () => {
  // page not found and no NF pagetype
  const siteSettings = useSiteSettingsStore();
  let siteSettingsObj: any = { ...siteSettings.$state };

  // add pagetype NF Not Found to the object
  siteSettingsObj["PageType"] = "NF";
  return siteSettingsObj;
}

export const noLanguageInURL = (url: any) => { // nl/contact
  const dataAll = useDataAll()
  if (!url.params?.slug || url.params.slug.length === 0) return true;
  return (dataAll.getLanguages().filter((i: any) => i === url.params.slug[0]).length == 0)

}

export const isNVEARPage = (pageItem: PageOverview | undefined, url: any) => {
  if (!isset(pageItem)) {
    // no "normal" page under the NVEAR index, so check if there is some news or events etc in the route
    return getNVEAROverviewSlugIndex(url.params?.slug) == -1 ? false : true;
  }
  else {
    return false;
  }
}

export const getNVEAROverviewSlugIndex = (slugs: any) => {
  // search slugs for NVEAR occurence, if so return index number
  if (!slugs || !Array.isArray(slugs)) return -1;
  const NVEAROverviewMapping = getNVEAROverviewMapping()
  let returnValue = -1;
  for (let index = 0; index < slugs.length; index++) {
    const slug = slugs[index];
    if (isset(NVEAROverviewMapping[slug])){
      // only return index if NVEAR page exists
      if (isset(slugs[index+1])){
        return index;
      }
    }
  }
  return returnValue
}

export const getNVEAROverviewMapping = () => {
  // Build object with NVEAR overviews
  NVEAROverviewMapping = Object.fromEntries(
    ["news", "event", "vacancy", "action", "reference"].map(key => [
      getNVEARprepathFill(key), // value -> new key
      key // key -> new value
    ])
  );

  return NVEAROverviewMapping;
}

export const getNVEARprepathFill = (nvearType: string) => {
  const NVEARData = usePageOverviewStore().getPageByType(pageTypeNVEAROverview[nvearType])
  if (NVEARData && NVEARData.NameUrl){
      return NVEARData.NameUrl;
  }
  return nvearType;
}

export const formatNVEARPage = async (url: any) => {
  const routePos = getNVEAROverviewSlugIndex(url.params.slug)
  const nvearStart = url.params.slug[routePos]
  const nvearChild = url.params.slug[routePos + 1]
  const contentTypeMapping = getNVEAROverviewMapping()

  if (contentTypeMapping[nvearStart]) {
      const siteSettings = useSiteSettingsStore();
      if (contentTypeMapping[nvearStart] === 'vacancy' && getYesNo(siteSettings, 'Carerix')) {
          return await formatVacancyDetail(nvearChild)
      }

      return getNVEARContent(contentTypeMapping[nvearStart], nvearChild);
  }

  return null
}

const getNVEARType = (url: any): string => {
  const routePos = getNVEAROverviewSlugIndex(url.params.slug)
  const nvearStart = url.params.slug[routePos]
  const contentTypeMapping = getNVEAROverviewMapping()
  return contentTypeMapping[nvearStart]
}

export const formatVacancyDetail = async (slug: string) => {
  try {
    const { vacancyRepository } = await import('@/layers/vacancies/repositories/vacancyRepository.js')
    const vacancyData = await vacancyRepository.getBySlug(slug)

    if (!vacancyData) return null

    return {
        ...vacancyData,
        PageType: 'VA',
        Title: vacancyData.title || vacancyData.Title,
        NameMenu: vacancyData.title || vacancyData.Title,
        NameUrl: slug,
        BrowserTitle: vacancyData.title || vacancyData.Title,
        MetaTitle: vacancyData.title || vacancyData.Title,
        MetaDescription: vacancyData.description?.replace(/<[^>]*>/g, '').substring(0, 160) || '',
        MetaKeywords: '',
        Code: slug
    }
  } catch (error) {
      console.error('Failed to format vacancy detail:', error)
      return null
  }
}

export const formatContentPage = (pageItem: PageOverview | undefined, url: any) => {
  // If no content is found, check for an article ID in the last route param
  if (!isset(pageItem)) { //pageItem == "" ||
      if (checkForArticleInUrl(url)) {
          return { "PageType": "PD" };
      } 
      else {
        pageItem = usePageOverviewStore().getPageByType("NF");
        const event = useRequestEvent();
        if (event) setResponseStatus(event, 404);
        return getPageContent(pageItem);
      }
  }

  // Clear cart for thank you pages (PageType "WT")
  if (pageItem && pageItem.PageType === "WT" && pageItem.NameUrl === "bedankt") {
    (async () => {
        try {
            const { shoppingCartService } = await import('@/layers/checkout/services/shoppingCartService');
            const { clearCart } = shoppingCartService();
            await clearCart();
        } catch (error) {
            console.error("Error clearing cart:", error);
        }
    })();
  }

  // Return the content JSON from the API call
  return getPageContent(pageItem)
}
const checkForArticleInUrl = (url: { path: string }): boolean => {
  const dataAll = useDataAll()
  const segments = url.path.split('/').filter((s) => s.length > 0)

  // /articles/<id>-<slug>: the part before the - is het article-id
  const index = segments.findIndex((s) => s.toLowerCase() === ARTICLE_PATH)
  if (index === -1) {
    return false
  }

  const segment = decodeURIComponent(segments[index + 1] ?? '')
  const articleId = segment.split('-')[0] ?? ''
  if (articleId.length >= 1) {
    dataAll.setDataVar('articleId', articleId)
    return true
  }
  return false
}


// this doesn't yet check if params.slug[0] is a language, but that should be done in the calling function
// const languageInURLNoRouteParam = (url: any) => { return (!isset(url.params.slug[1]) || url.params.slug[1] == ""); }
const languageInURLNoRouteParam = (url: any) => { 
  const hasLanguage = !noLanguageInURL(url)
  if (hasLanguage) {
    return (!isset(url.params.slug[1]) || url.params.slug[1] == "");
  }
  return false;
}